module.exports = __webpack_public_path__ + "static/media/tape-measure.29b6bd64.svg";